import { defineStore } from "pinia";
import { getIpToLatLng } from "~/api/api";

/** IP 定位失败时的兜底：香港大致中心 */
const DEFAULT_LOCATION = {
	lat: 22.3193,
	lng: 114.1694,
	country: "HK",
};

export const useUserLocationStore = defineStore(
	"userLocation",
	() => {
		const lat = ref(null);
		const lng = ref(null);
		const country = ref("");
		const ready = ref(false);
		const loading = ref(false);

		let pendingRequest = null;

		function setLocation(data) {
			if (!data || data.lat == null || data.lng == null) return false;
			lat.value = Number(data.lat);
			lng.value = Number(data.lng);
			country.value = data.country || "";
			ready.value = true;
			return true;
		}

		function applyDefaultLocation() {
			setLocation(DEFAULT_LOCATION);
			return { lat: lat.value, lng: lng.value, country: country.value };
		}

		async function fetchLocation() {
			if (!import.meta.client) return null;

			if (pendingRequest) {
				return pendingRequest;
			}

			loading.value = true;
			pendingRequest = getIpToLatLng()
				.then(response => {
					if (response?.code === 200 && response?.data && setLocation(response.data)) {
						return { lat: lat.value, lng: lng.value, country: country.value };
					}
					return applyDefaultLocation();
				})
				.catch(error => {
					console.error("getIpToLatLng failed", error);
					return applyDefaultLocation();
				})
				.finally(() => {
					loading.value = false;
					pendingRequest = null;
				});

			return pendingRequest;
		}

		async function ensureLocation({ force = false } = {}) {
			if (!force && ready.value && lat.value != null && lng.value != null) {
				return { lat: lat.value, lng: lng.value, country: country.value };
			}

			return (await fetchLocation()) || applyDefaultLocation();
		}

		return {
			lat,
			lng,
			country,
			ready,
			loading,
			setLocation,
			ensureLocation,
		};
	},
	{
		persist: {
			storage: import.meta.client ? sessionStorage : undefined,
			paths: ["lat", "lng", "country", "ready"],
		},
	}
);
